module.exports = __webpack_public_path__ + "img/purchase.810c30c0.svg";